import * as React from 'react';

import Container from '@mui/material/Container';
import Alert from '@mui/material/Alert';
import AlertTitle from '@mui/material/AlertTitle';

export interface IErrorInfo {
   errorCode?: string
   errorText?: string
   silent?: boolean
   failed?: boolean
}

interface ErrorAlertProps {
   errorCode?: string | null
   errorText?: string | null
   silent?: boolean
   failed?: boolean
}

export const ErrorAlert = ({ errorCode, errorText, silent, failed }: ErrorAlertProps) => {
   if (silent) {
      return null;
   }
   return (
      <Container>
         <Alert severity={(failed === undefined || failed) ? "error" : "info"} sx={{ marginTop: 10 }}>
            <AlertTitle>
                {errorCode}
            </AlertTitle>
            {errorText}
         </Alert>
      </Container>
   );
}

export default ErrorAlert;